import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "@/components/LoginView";
import MainView from "@/components/MainView";
import ReleaseInspectorView from "@/components/ReleaseInspectorView";


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: MainView
    },
    {
        path: '/login',
        name: 'Login',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: LoginView
    },
    {
        path: '/release/:app/:version',
        name: 'ReleaseInspector',
        component: ReleaseInspectorView
    }
]

const router = new VueRouter({
    base: process.env.VUE_APP_FE_ROUTER_BASE,
    mode: 'history',
    routes
})

export default router
